import {
  IsBoolean,
  IsNumber,
  IsString,
  MaxLength,
  MinLength,
} from 'class-validator';

export class CreateSweetFaceEmployeeRequestDto {
  // @ApiProperty({
  //   description: 'Employee first name',
  //   nullable: false,
  //   example: 'John',
  // })
  @IsString()
  @MinLength(1)
  @MaxLength(255)
  firstName: string;

  // @ApiProperty({
  //   description: 'Employee last name',
  //   nullable: false,
  //   example: 'Smith',
  // })
  @IsString()
  @MinLength(1)
  @MaxLength(255)
  lastName: string;

  // @ApiProperty({
  //   description: 'Manager PIN active boolean flag',
  //   nullable: false,
  //   example: true,
  // })
  @IsBoolean()
  managerPinActive: boolean;

  // @ApiProperty({
  //   description: 'Pie Merchant ID',
  //   example: 7,
  // })
  @IsNumber()
  pieMerchantId: number;
}
